import { render, staticRenderFns } from "./KeyboardTips.vue?vue&type=template&id=74bb8dc0&scoped=true&"
import script from "./KeyboardTips.vue?vue&type=script&lang=js&"
export * from "./KeyboardTips.vue?vue&type=script&lang=js&"
import style0 from "./KeyboardTips.vue?vue&type=style&index=0&id=74bb8dc0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74bb8dc0",
  null
  
)

export default component.exports